<div class="p-6 sm:p-10">
    <fuse-card class="flex flex-col px-8 py-6 pb-4">
        <div class="mt-2">
            <div class="mb-6 flex gap-3">
                <mat-icon class="text-red-600" svgIcon="mat_outline:warning"></mat-icon>
                <h3 class="text-xl font-semibold text-red-600">Verknüpfung fehlgeschlagen</h3>
            </div>

            <fuse-alert class="mb-6" [appearance]="'outline'" [showIcon]="true" type="error">
                <span>
                    <strong>Fehler:</strong> Die aufgerufene URL scheint nicht zu stimmen. Achte darauf, dass du den
                    Button auf der Integrationsseite nutzt, um die Verknüpfung zu Microsoft einzurichten. Wenn du
                    trotzdem hier gelandet bist, versuche es bitte noch einmal. Solltest du diese Nachricht weiterhin
                    sehen, melde dich bitte beim AI Lotsen Team.
                </span>
            </fuse-alert>
        </div>
    </fuse-card>
</div>
